export const APPLICATION_FIELD = "applicationField";
export const PRIORITY = "testRequestPriority";
export const APPROVER = "suggestedApprover";
export const ASSIGNEE = "assignee";
export const BACKGROUND_INFORMATION = "backgroundInformation";
export const BUSINESS_TYPE = "businessType";
export const BUSINESS_UNIT = "businessUnit";
export const CONFIDENTIALITY = "projectConfidentiality";
export const CRM_NO = "crmProjectNo";
export const CSC_LAB = "cscLaboratory";
export const CURRENCY = "pnsPotentialCurrencyCode";
export const CUSTOMER_CLASSIFICATION = "customerClassification";
export const CUSTOMER_PART = "customerPartList";
export const DEADLINE = "deadline";
export const DEBITOR_NO = "debitorNumber";
export const DIRECT_CUSTOMER = "directCustomer";
export const DIRECT_CUSTOMER_CGR = "directCustomerCGR";
export const DIRECT_CUSTOMER_LOCATION = "directCustomerLocation";
export const DIRECT_CUSTOMER_MCGR = "directCustomerMCGR";
export const DISTRIBUTOR = "distributor";
export const FINISHING_DATE = "estimatedFinishingDate";
export const INTERNAL_CONTACT = "furtherInternalContact";
export const INTERNAL_CONTACTS = "furtherInternalContacts";
export const MARKET_SEGMENT = "marketSegment";
export const OEM = "oem";
export const OPPORTUNITY_PRODUCTS = "opportunityProducts";
export const PNS = "pnsPotential";
export const PROCESS_DETAIL = "processDetail";
export const PROCESS_TYPE = "processType";
export const PRODUCTS = "products";
export const PRODUCT_REFERENCES = "productReferences";
export const PROTOTYPE_PRODUCT_REFERENCES = "prototypeProductReferences";
export const COMPETITOR_PRODUCT_REFERENCES = "competitorProductReferences";
export const REPORT_LANGUAGE = "reportLanguage";
export const REPORT_USAGE = "reportUsage";
export const SALES_TEAM = "salesTeam";
export const SOLUTION = "currentSolution";
export const SPECIFICATION = "specifications";
export const SUBSTRATES = "substrates";
export const TEST_EFFORT_IN_DAYS = "estimatedTestEffortInDays";
export const TEST_LOCATION = "testLocation";
export const TEST_PROGRAM = "testProgram";
export const TITLE = "title";
export const TEST_PURPOSE = "testPurpose";
export const EXTERNAL_DEVELOPMENT_BUDGET = "externalDevelopmentBudget";
export const EXTERNAL_DEVELOPMENT_BUDGET_CURRENCY_CODE = "externalDevelopmentBudgetCurrencyCode";
export const SPECIFICATION_NEEDED = "specificationNeeded";
